import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NosotrosPage = lazy(() => import('../pages/nosotros/page'));
const ProductosPage = lazy(() => import('../pages/productos/page'));
const SucursalesPage = lazy(() => import('../pages/sucursales/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const MantenimientoPage = lazy(() => import('../pages/mantenimiento/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />
  },
  {
    path: '/productos',
    element: <ProductosPage />
  },
  {
    path: '/sucursales',
    element: <SucursalesPage />
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />
  },
  {
    path: '/mantenimiento',
    element: <MantenimientoPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
